<div class="col-md-12" style="overflow:hidden;">
  <div class="border rounded-2 p-4">
    <h3 class="text-center">Kaizen Actuals Tracking</h3>
    <a routerLink="/addEditKaizen/{{kaizenId}}">Kaizen No. : K{{actualDTO.kaizenNumber}}</a>
    <div>{{actualDTO.kaizenDescription}}</div>
    <div></div>
  </div>
  <br>
    <form [formGroup]="formActuals" (ngSubmit)="onSubmit(formActuals)">
      @for (ac of getAccountFormArray().controls; track ac; let i = $index) {
        <ng-container formArrayName="accountArray">
          <div [formGroupName]="i">
            <div class="card"  >
              <h5 class="card-header">Account #{{i+1}}: {{actualsAccount[i].savingsMeasureName}} ({{actualsAccount[i].glAccountImpcatAreaName}})</h5>
              <span style="text-align: right;">Currrency: {{actualsAccount[i].currencyCode}}</span>
              <div class="card-body">
                <div id='showTotalCostTable' class="well">
                  <table style="width: 100%;" class="table table-bordered">
                    <thead>
                      <tr>
                        <td></td>
                        @for (m of actualHeaderMonthList; track m) {
                          <th  style="text-align: center;">{{m.Text}}-{{(fiscalYear[m.Value-1]).substring(2,4)}}</th>
                        }
                      </tr>
                    </thead>
                    <tbody >
                      <tr>
                        <th>Plan</th>
                        @for (m of accountsKaizenMonthlySaving[i]; track m) {
                          <td style="text-align: left;">{{actualsAccount[i].savingsMeasureId==2?
                            m.processReduction : (actualsAccount[i].savingsMeasureId==3? m.twtReduction : (actualsAccount[i].savingsMeasureId==4?
                          m.monthlySavings == 0 ? '$' +0 :'$'+m.costPerUnitSavings : '$'+ m.monthlySavings ))}}</td>
                        }
                      </tr>
                      @if (!isEditable) {
                        <tr >
                          <th>Actual</th>
                          @for (a of actualArray[i]; track a) {
                            <td >{{actualsAccount[i].savingsMeasureId == 4 ? '$' : (actualsAccount[i].savingsMeasureId == 5 ? '$' : '') }}{{a.actualValue}}</td>
                          }
                        </tr>
                      }
                      @if (isEditable) {
                        <tr >
                          <th>Actual</th>
                          <td><div style="float: left;padding:8px 0 0 0;height:2px;margin:0px">{{actualsAccount[i].savingsMeasureId == 4 ? '$' : (actualsAccount[i].savingsMeasureId == 5 ? '$' : '') }}</div><input type="text" (keydown.enter)="$event.preventDefault()"  class="form-control input-width2" style="margin-left: 0 !important;padding:0px 3px"
                        (change)="onActualChangeEvent($event,i)" placeholder="" formControlName="ActualsMon0" /></td>
                        <td><div style="float: left;padding:8px 0 0 0;height:2px;margin:0px">{{actualsAccount[i].savingsMeasureId == 4 ? '$' : (actualsAccount[i].savingsMeasureId == 5 ? '$' : '') }}</div><input type="text" (keydown.enter)="$event.preventDefault()"  class="form-control input-width2" style="margin-left: 0 !important;padding:0px 3px"
                      (change)="onActualChangeEvent($event,i)" placeholder="" formControlName="ActualsMon1" /></td>
                      <td><div style="float: left;padding:8px 0 0 0;height:2px;margin:0px">{{actualsAccount[i].savingsMeasureId == 4 ? '$' : (actualsAccount[i].savingsMeasureId == 5 ? '$' : '') }}</div><input type="text" (keydown.enter)="$event.preventDefault()"  class="form-control input-width2" style="margin-left: 0 !important;padding:0px 3px"
                    (change)="onActualChangeEvent($event,i)" placeholder="" formControlName="ActualsMon2" /></td>
                    <td><div style="float: left;padding:8px 0 0 0;height:2px;margin:0px">{{actualsAccount[i].savingsMeasureId == 4 ? '$' : (actualsAccount[i].savingsMeasureId == 5 ? '$' : '') }}</div><input type="text" (keydown.enter)="$event.preventDefault()"  class="form-control input-width2" style="margin-left: 0 !important;padding:0px 3px"
                  (change)="onActualChangeEvent($event,i)" placeholder="" formControlName="ActualsMon3" /></td>
                  <td><div style="float: left;padding:8px 0 0 0;height:2px;margin:0px">{{actualsAccount[i].savingsMeasureId == 4 ? '$' : (actualsAccount[i].savingsMeasureId == 5 ? '$' : '') }}</div><input type="text" (keydown.enter)="$event.preventDefault()"  class="form-control input-width2" style="margin-left: 0 !important;padding:0px 3px"
                (change)="onActualChangeEvent($event,i)" placeholder="" formControlName="ActualsMon4" /></td>
                <td><div style="float: left;padding:8px 0 0 0;height:2px;margin:0px">{{actualsAccount[i].savingsMeasureId == 4 ? '$' : (actualsAccount[i].savingsMeasureId == 5 ? '$' : '') }}</div><input type="text" (keydown.enter)="$event.preventDefault()"  class="form-control input-width2" style="margin-left: 0 !important;padding:0px 3px"
              (change)="onActualChangeEvent($event,i)" placeholder="" formControlName="ActualsMon5" /></td>
              <td><div style="float: left;padding:8px 0 0 0;height:2px;margin:0px">{{actualsAccount[i].savingsMeasureId == 4 ? '$' : (actualsAccount[i].savingsMeasureId == 5 ? '$' : '') }}</div><input type="text" (keydown.enter)="$event.preventDefault()"  class="form-control input-width2" style="margin-left: 0 !important;padding:0px 3px"
            (change)="onActualChangeEvent($event,i)" placeholder="" formControlName="ActualsMon6" /></td>
            <td><div style="float: left;padding:8px 0 0 0;height:2px;margin:0px">{{actualsAccount[i].savingsMeasureId == 4 ? '$' : (actualsAccount[i].savingsMeasureId == 5 ? '$' : '') }}</div><input type="text" (keydown.enter)="$event.preventDefault()"  class="form-control input-width2" style="margin-left: 0 !important;padding:0px 3px"
          (change)="onActualChangeEvent($event,i)" placeholder="" formControlName="ActualsMon7" /></td>
          <td><div style="float: left;padding:8px 0 0 0;height:2px;margin:0px">{{actualsAccount[i].savingsMeasureId == 4 ? '$' : (actualsAccount[i].savingsMeasureId == 5 ? '$' : '') }}</div><input type="text"  (keydown.enter)="$event.preventDefault()" class="form-control input-width2" style="margin-left: 0 !important;padding:0px 3px"
        (change)="onActualChangeEvent($event,i)" placeholder="" formControlName="ActualsMon8" /></td>
        <td><div style="float: left;padding:8px 0 0 0;height:2px;margin:0px">{{actualsAccount[i].savingsMeasureId == 4 ? '$' : (actualsAccount[i].savingsMeasureId == 5 ? '$' : '') }}</div><input type="text" (keydown.enter)="$event.preventDefault()"  class="form-control input-width2" style="margin-left: 0 !important;padding:0px 3px"
      (change)="onActualChangeEvent($event,i)" placeholder="" formControlName="ActualsMon9" /></td>
      <td><div style="float: left;padding:8px 0 0 0;height:2px;margin:0px">{{actualsAccount[i].savingsMeasureId == 4 ? '$' : (actualsAccount[i].savingsMeasureId == 5 ? '$' : '') }}</div><input type="text" (keydown.enter)="$event.preventDefault()"  class="form-control input-width2" style="margin-left: 0 !important;padding:0px 3px"
    (change)="onActualChangeEvent($event,i)" placeholder="" formControlName="ActualsMon10" /></td>
    <td><div style="float: left;padding:8px 0 0 0;height:2px;margin:0px">{{actualsAccount[i].savingsMeasureId == 4 ? '$' : (actualsAccount[i].savingsMeasureId == 5 ? '$' : '') }}</div><input type="text" (keydown.enter)="$event.preventDefault()"  class="form-control input-width2" style="margin-left: 0 !important;padding:0px 3px"
  (change)="onActualChangeEvent($event,i)" placeholder="" formControlName="ActualsMon11" /></td>
</tr>
}
<tr>
  <th>Variance</th>
  @for (m of gapActual[i]; track m) {
  <td>
    <span [style.color]="m >= 0 ? 'green' : 'red'">
      {{actualsAccount[i].savingsMeasureId == 4 ? '$' : (actualsAccount[i].savingsMeasureId == 5 ? '$' : '')}}{{m |
      number:'1.2-2'}}
    </span>
  </td>
  }
</tr>
</tbody>
</table>
</div>
</div>
</div>
</div>
<br>
</ng-container>
}
@if (!multipleCurrencies) {
  <div class="card">
    <div class="card-body" >
      <h5 class="card-header">Monthly Net Impact</h5>
      <div class="col-md-12">
        <table   class="table table-bordered">
          <thead>
            <tr>
              <th></th>
              @for (m of actualHeaderMonthList; track m) {
                <th  style="text-align: center;">{{m.Text}}-{{(fiscalYear[m.Value-1]).substring(2,4)}}</th>
              }
            </tr>
          </thead>
          <tbody >
            <tr>
              <th>Plan TWT Impact</th>
              @for (t of twtImpactPlan; track t) {
                <td style="text-align: center;">{{t | number:'1.2-2'}}</td>
              }
            </tr>
            <tr>
              <th>Actual TWT Impact</th>
              @for (t of twtImpactActual; track t) {
                <td style="text-align: center;">{{t | number:'1.2-2'}}</td>
              }
            </tr>
            <tr>
              <th>Variance TWT Impact</th>
              @for (t of twtImpactGap; track t) {
                <td style="text-align: center;">{{t | number:'1.2-2'}}</td>
              }
            </tr>
            <tr>
              <th>Plan Cost Impact</th>
              @for (t of costImpactPlan; track t) {
                <td style="text-align: center;">${{t | number}}</td>
              }
            </tr>
            <tr>
              <th>Actual Cost Impact</th>
              @for (t of costImpactActual; track t) {
                <td style="text-align: center;">${{t | number}}</td>
              }
            </tr>
            <tr>
              <th>Variance Cost Impact</th>
              @for (t of costImpactGap; track t) {
                <td style="text-align: center;">${{t | number}}</td>
              }
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
}

<div>
  @if (multipleCurrencies) {
    <h3 style="text-align: center;">Net Savings cannot be calculated because this Kaizen has accounts with different currencies.</h3>
  }
  <br>
    <br>
    </div>

    @if (isEditable && actualDTO.kaizenState != 'Complete') {
      <div>
        <div class="card">
          <h5 class="card-header">Kaizen progress</h5>
          <div class="col-md-12">
            <div  ><br>
              @if (!isKaizenComplete) {
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group row" >
                      <label for="kaizenCancelDelete" class="col-sm-10 col-form-label">Cancel/Delete Kaizen:</label>
                      <label class="switch">
                        <input id="kaizenCancelDelete" formControlName="kaizenCancelDelete" type="checkbox"
                          (change)="cancelDeleteChecked($event)">
                          <span class="slider round"> </span>
                        </label>
                      </div>
                    </div>
                    <div class="col-md-1">
                      <span><label class="slider-progress-label">{{cancelKaizenYesNo}}</label></span>
                    </div>
                    <div class="col-md-7">
                      @if (isCancelDelete) {
                        <div class="form-group row">
                          <label for="additionalKaizenSourceDescription" class="col-sm-4 col-form-label">Reason for
                          cancellation:</label>
                          <div class="col-sm-8 p-1">
                            <textarea class="form-control" formControlName="reasonForCancellation"
                              name="reasonForCancellation" placeholder="Reason for cancellation" rows="3"
                            class="form-control"></textarea>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                }
                @if (!isCancelDelete) {
                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group row">
                        <label for="kaizenComplete" class="col-sm-10 col-form-label">Set as completed Kaizen:</label>
                        <label class="switch">
                          <input id="kaizenComplete" formControlName="kaizenComplete" type="checkbox"
                            (change)="kaizenCompleteChecked($event)">
                            <span class="slider round"></span>
                          </label>
                        </div>
                      </div>
                      <div class="col-md-1">
                        <span><label class="slider-progress-label">{{completeYesNo}}</label></span>
                      </div>
                      @if (isKaizenComplete) {
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label for="completionnDate" class="col-sm-4 p-1 col-form-label">Completion Date:</label>
                            <div class="col-sm-8 p-1">
                              <div class="input-group">
                                <select class="form-select"   formControlName="completionYear" required>
                                  <option value="">Select Year</option>
                                  @for (year of yearList; track year) {
                                    <option [value]="year.value">{{year.text}}</option>
                                  }
                                </select>
                                <select class="form-select"  formControlName="completionMonth" (change)="changeCompletionMonth($event)" required>
                                  <option value="">Select Month</option>
                                  @for (month of monthList; track month) {
                                    <option [value]="month.Value">{{month.Text}}</option>
                                  }
                                </select>
                                <select class="form-select"   formControlName="completionDay" required>
                                  <option value="">Select Day</option>
                                  @for (day of days; track day) {
                                    <option [value]="day.Id">{{day.Name}}</option>
                                  }
                                </select>
                                <br>
                                  <br>
                                  </div>
                                </div>
                              </div>
                              <!-- <div class="form-group row">
                              <label for="submitBpaks" class="col-sm-4 col-form-label">Submit to BPAKS:</label>
                              <label class="switch">
                                <input id="submitBpaks" formControlName="submitBpaks" type="checkbox"
                                  (change)="submitBpaksChecked($event)">
                                  <span class="slider round"></span>
                                </label>
                                <div class="col-sm-3">
                                  <span><label class="slider-label">{{submitBpaksYesNo}}</label></span>
                                </div>
                              </div> -->
                            </div>
                          }
                        </div>
                      }
                      <div class="col-8"> <p>Note: Only Kaizens with no Actuals will have the Cancel/Delete Kaizen option</p></div>
                    </div>
                  </div>
                </div>
              </div>
            }
            <br>
              <div class="col-md-12">
                <button mat-flat-button type="button" (click)="cancel()" color="primary">Cancel</button>
                <button mat-flat-button color="primary" type="submit" color="primary"
                [disabled]="!formActuals.valid" (keydown.enter)="$event.preventDefault()">Save</button>
              </div>
              <br>
                <br>
                </form>
              </div>




